import React, { useState } from 'react';

import TabbedViewWithDateSelect from '../../components/TabbedViewWithDateSelect/TabbedViewWithDateSelect';
import { ChassisDrop, ChassisLineOn } from '../../components';
import { usePlantAndLinesStore } from '../../providers/PlantAndLinesStore/PlantAndLinesStore';
import { JLR_PLANT } from '../../constants';

const ChassisDropView = () => {
  const [plant] = usePlantAndLinesStore().plantState;
  const [asnCount, setAsnCount] = useState(0);
  const setCount = count => {
    setAsnCount(count);
  };

  const [lineOutCount, setLineOutCount] = useState(0);
  const setAsnLineOutCount = count => {
    setLineOutCount(count);
  };

  const title = 'Chassis Line';

  return (
    <div>
      <TabbedViewWithDateSelect
        tabs={[
          {
            label: 'ASN Details',
            title: 'ASN details',
            count: asnCount,
            countColor: plant.label === JLR_PLANT ? 'green' : 'blue',
            backgroundColor: plant.label === JLR_PLANT ? 'green' : 'blue',
            component: ChassisDrop,
            props: {
              handleCountChange: setCount,
            },
          },
          {
            label: 'Lineout',
            title: 'Lineout Update',
            count: lineOutCount,
            countColor: plant.label === JLR_PLANT ? 'white' : 'red',
            backgroundColor: plant.label === JLR_PLANT ? 'red' : 'white',
            component: ChassisLineOn,
            props: {
              handleCountChange: setAsnLineOutCount,
            },
          },
        ]}
        pageTitle={title}
      />
    </div>
  );
};

export default ChassisDropView;
